<div class="thumbnail-container" *ngIf="!isLoading && evidenceData.length > 0">
  <div class="thumbnail-grid">
    <div class="evidence-card" *ngFor="let evidence of evidenceData; let i = index" (click)="onEvidenceClick(i)">
      <!-- Image section -->
      <div class="evidence-image-container">
        <img [src]="getImageUrl(evidence)" [alt]="getEvidenceTitle(evidence)" class="evidence-image"
          [class.loading]="evidence.imageLoading" (error)="$event.target.src='assets/images/placeholder-image.png'" />
        <div *ngIf="evidence.imageLoading" class="image-loading-overlay">
          <div class="loading-spinner"></div>
        </div>
      </div>

      <!-- Information section -->
      <div class="evidence-info">
        <!-- Store info -->
        <div class="evidence-field" *ngIf="getStoreNumber(evidence)">
          <span class="field-label">Store</span>
          <span class="field-value">{{ getStoreNumber(evidence) }}</span>
        </div>

        <!-- Assessment info -->
        <div class="evidence-field" *ngIf="getAssessmentType(evidence)">
          <span class="field-label">Assessment</span>
          <span class="field-value">{{ getAssessmentType(evidence) }}</span>
        </div>

        <!-- Section Heading -->
        <div class="evidence-field" *ngIf="getSectionHeading(evidence)">
          <span class="field-label">Section Heading</span>
          <span class="field-value">{{ getSectionHeading(evidence) }}</span>
        </div>

        <!-- Control Name< -->
        <div class="evidence-field" *ngIf="getEvidenceTitle(evidence)">
          <span class="field-label">Control Name</span>
          <span class="field-value">{{ getEvidenceTitle(evidence) }}</span>
        </div>

        <!-- Finding Title -->
        <div class="evidence-field" *ngIf="getFindingTitle(evidence) && evidenceType === 'mrr'">
          <span class="field-label">Finding Title</span>
          <span class="field-value">{{ getFindingTitle(evidence) }}</span>
        </div>

        <!-- Date -->
        <div class="evidence-field" *ngIf="getEvidenceDate(evidence)">
          <span class="field-label">Date</span>
          <span class="field-value">{{ getEvidenceDate(evidence) | date:'dd MMM y' }}</span>
        </div>

        <!-- View link -->
        <div class="evidence-actions">
          <a class="view-link" (click)="onEvidenceClick(i); $event.stopPropagation()">
            View
          </a>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isLoading" class="loader-container">
  <div class="loading-wapple"></div>
</div>

<div *ngIf="evidenceData.length === 0 && !isLoading" class="no-evidence-container">
  <h3 class="none-found-message">{{ noEvidenceMessage }}</h3>
</div>